/**
 * Centralized registry of all localStorage keys used by the application.
 *
 * Categories:
 *   AUTH        — cleared on logout
 *   USER_DATA   — cleared on logout
 *   CACHE       — safe to clear anytime
 *   PREFERENCES — kept across accounts (device-level)
 *   MIGRATION   — never cleared (one-time flags)
 */

export const STORAGE_KEYS = {
  // AUTH
  GOOGLE_TOKEN: 'adhd-planner-google-token',
  GOOGLE_AUTH:  'adhd-planner-google-auth',

  // USER DATA
  CUSTOM_TASKS:       'adhd-planner-custom-tasks',   // legacy pre-IndexedDB
  COMPLETED_TASKS:    'adhd-planner-completed',       // legacy pre-IndexedDB
  CUSTOM_TEMPLATES:   'adhd_custom_templates',
  SCHEDULE_SETTINGS:  'adhd_schedule_settings',
  AUTO_GENERATION:    'adhd_auto_generation',
  LAST_GENERATED:     'adhd_last_generated_week',
  USER_PROFILE:       'adhd-user-profile',
  COMPANION:          'adhd-companion',
  ACTIVE_QUESTS:      'adhd-active-quests',
  CALENDAR_MAPPING:   'adhd-calendar-mapping',
  LAST_SYNC:          'adhd_last_sync',
  LAST_EXPORT:        'adhd_last_export',
  SETUP_COMPLETED:    'adhd_setup_completed',
  ADVANCED_SETTINGS:  'adhd_planner_advanced_settings',

  // AI
  AI_CACHE: 'adhd-planner-ai-cache',
  AI_USAGE: 'adhd-planner-ai-usage',

  // CACHE
  WEATHER_CACHE: 'adhd_weather_cache',

  // PREFERENCES (kept on logout)
  THEME_MODE:   'adhd-planner-theme-mode',
  LOCAL_MODE:   'adhd_local_mode',
  HAS_VISITED:  'adhd_has_visited',

  // MIGRATION FLAGS (never cleared)
  MIGRATED_IDB: 'adhd-planner-migrated-to-idb',
  MIGRATED_V2:  'adhd-planner-migrated-v2',
};

/**
 * Static keys cleared when the user logs out.
 * Dynamic keys (e.g. google_sync_YYYY-MM-DD) are handled
 * by iterating localStorage in clearAllUserData().
 */
export const USER_DATA_KEYS = [
  STORAGE_KEYS.GOOGLE_TOKEN,
  STORAGE_KEYS.GOOGLE_AUTH,
  STORAGE_KEYS.CUSTOM_TASKS,
  STORAGE_KEYS.COMPLETED_TASKS,
  STORAGE_KEYS.CUSTOM_TEMPLATES,
  STORAGE_KEYS.SCHEDULE_SETTINGS,
  STORAGE_KEYS.AUTO_GENERATION,
  STORAGE_KEYS.LAST_GENERATED,
  STORAGE_KEYS.USER_PROFILE,
  STORAGE_KEYS.COMPANION,
  STORAGE_KEYS.ACTIVE_QUESTS,
  STORAGE_KEYS.CALENDAR_MAPPING,
  STORAGE_KEYS.LAST_SYNC,
  STORAGE_KEYS.LAST_EXPORT,
  STORAGE_KEYS.SETUP_COMPLETED,
  STORAGE_KEYS.ADVANCED_SETTINGS,
  STORAGE_KEYS.AI_CACHE,
  STORAGE_KEYS.AI_USAGE,
  STORAGE_KEYS.WEATHER_CACHE,
];

export default STORAGE_KEYS;
